<template>
  <b-overlay :show="loading">
    <b-row>
        <b-col cols="12">
            <b-card-actions :no-actions="true" title="List Barang">
                
                <section class="d-flex justify-content-between">
                  <section>
                    <b-button
                        v-if="allowCreate()"
                        variant="primary"
                        class="mb-2 mr-2"
                        @click.prevent="$router.push({ name: 'route-barang-add' })"
                    >
                        Tambah
                    </b-button>
                    <b-button
                        v-if="allowDelete() && showMassDelButton"
                        variant="outline-danger"
                        class="mb-2"
                        @click.prevent="confirmMassDelete"
                    >
                        Hapus
                    </b-button>
                  </section>
                  <section class="d-flex justify-content-end">
                    <b-button variant="outline-primary" @click.prevent="exportBarang">
                      Export
                    </b-button>
                  </section>
                </section>
              <!-- search input -->

              <!--  -->
              <data-barang :datas="items" @refreshData="getData" />
              <!-- / -->
            </b-card-actions>
        </b-col>
    </b-row>
  </b-overlay>
  </template>
  
  <script>
  import service from '@/services'
  import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
  import {
    BOverlay,
    BRow, BCol,
    BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
    BButton, BCardText, BTable
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import store from '@/store/index'
  import DataBarang from './components/DataBarang.vue';
  
  export default {
    components: {
        DataBarang,
        BOverlay,
        BButton,
        BRow,
        BCol,
      BCardActions,
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
    },
    data() {
      return {
        loading: false,
        params: {
          order: 'desc'
        },
        items: [],
        showMassDelButton: false,
        status: [{
          1: 'Current',
          2: 'Professional',
          3: 'Rejected',
          4: 'Resigned',
          5: 'Applied',
        },
        {
          1: 'light-primary',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-warning',
          5: 'light-info',
        }],
      }
    },
    methods: {
      async clearExportedFile(filename) {
        try {
            const config = {
                url: `/clear-export`,
                method: 'get',
                params: {
                    filename
                },
                headers: {
                    Authorization: `${localStorage.tokenType} ${localStorage.token}`
                }
            }
            const response = await service.sendRequest(config)

            return Promise.resolve(response.data)
        } catch (e) {
            if(e.response && e.response.data) {
                const blob = e.response.data
                const text = await blob.text()
                const errorJson = JSON.parse(text)

                return Promise.reject(errorJson)
            }
            return Promise.reject(e)        
        }
    },
    async print() {
        try {
            const config = {
                url: `/excel-data-barang`,
                method: 'get',
                headers: {
                    Authorization: `${localStorage.tokenType} ${localStorage.token}`
                }
            }
            const response = await service.sendRequest(config)

            return Promise.resolve(response.data)
        } catch (e) {
            return this.customRejectPromise(e)
        }
    },
    async exportBarang() {
      try {
        this.loading = true

        const response = await this.print()
        await window.open(response)
        setTimeout(async () => {
          // delete selected file
          const arrFile = response.split('/')
          const filename = arrFile[ arrFile.length - 1 ]

          await this.clearExportedFile(filename)
        }, 1000)

        this.loading = false
      }
      catch(e) {
        this.loading = false
        this.displayError(e)
        return false
      }
    },
      getData() {
        this.$store.dispatch('barang/getData', this.params)
        .then(() => {
          let items = JSON.parse( JSON.stringify(this.$store.state.barang.datas) )
          this.items = items
          this.totalRows = this.items.length
        })
        .catch(e => {
          console.error(e)
          this.displayError(e)

          return false
        })
      },
        onItemChecked(payload) {
          if(payload.selectedRows.length > 0) {
            this.showMassDelButton = true;
          }
          else {
            this.showMassDelButton = false;
          }
        }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current      : 'light-primary',
          Professional : 'light-success',
          Rejected     : 'light-danger',
          Resigned     : 'light-warning',
          Applied      : 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },
      direction() {
        if (store.state.appConfig.isRTL) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dir = true
          return this.dir
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = false
        return this.dir
      },
      
    },
    created() {
      this.getData()
        // this.rows = barang.list;
    },
  }
  </script>